import { render, staticRenderFns } from "./AllLifeTipDialog.vue?vue&type=template&id=22ebf990&scoped=true&"
import script from "./AllLifeTipDialog.vue?vue&type=script&lang=js&"
export * from "./AllLifeTipDialog.vue?vue&type=script&lang=js&"
import style0 from "./AllLifeTipDialog.vue?vue&type=style&index=0&id=22ebf990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ebf990",
  null
  
)

export default component.exports